var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrowRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.169516 0.989156C-0.049034 0.761559 -0.049034 0.393909 0.169516 0.166317C0.382463 -0.055439 0.74111 -0.055439 0.954054 0.166317L3.94105 3.2769C4.24118 3.58945 4.24118 4.09618 3.94105 4.40873L0.954054 7.51931C0.735506 7.7469 0.382463 7.7469 0.163913 7.51931C-0.0546376 7.29171 -0.0546376 6.92406 0.163913 6.69647L2.9042 3.84281L0.169516 0.989156Z",
    fill: "#F8F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69337 0.989156C3.47482 0.761559 3.47482 0.393909 3.69337 0.166317C3.90631 -0.055439 4.26496 -0.055439 4.4779 0.166317L7.4649 3.2769C7.76503 3.58945 7.76503 4.09618 7.4649 4.40873L4.4779 7.51931C4.25936 7.7469 3.90631 7.7469 3.68776 7.51931C3.46921 7.29171 3.46921 6.92406 3.68776 6.69647L6.42805 3.84281L3.69337 0.989156Z",
    fill: "#F8F7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRightIcon);
export default __webpack_public_path__ + "static/media/DoubleArrowRightIcon.381cb72b.svg";
export { ForwardRef as ReactComponent };